import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "InfoRequest" })
export default class InfoRequest extends Vue {
    public localizer: any = Localizer;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public infoRequestSubmit: any = { type: null };
    public types: any[] = [];
    public validationErrors: any[] = [];

    @Prop() readonly recaptchaSiteKey: string;

    get routes() {
        return (<any>window).App.routes;
    }

    get originPage() {
        return (<any>window).App.bag.OriginPage;
    }

    public async created() {
        await this.getData();
    }

    public async getData() {
        const result = (await Axios.post(this.routes.Support_GetInfoRequestData)).data;
        this.types = result.types;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;
        this.infoRequestSubmit.originpage = this.originPage;

        (<any>window).grecaptcha.enterprise.ready(async () => {
            const token = await (<any>window).grecaptcha.enterprise.execute(this.recaptchaSiteKey, { action: 'Submit' });
            try {
                await Axios.post(this.routes.Support_InfoRequest, this.infoRequestSubmit, { headers: { "RecaptchaVerificationToken": token } });

                this.isSuccess = true;

                GTagHelper.sendEvent("form_submit", "info_request", this.infoRequestSubmit.type);
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        });

        this.isLoading = false;
    }

    public closeModal() {
        let lgData = (<any>window).parent.lgData;
        for (let propertyName in lgData) {
            if (propertyName !== "uid" && lgData.hasOwnProperty(propertyName)) {
                if (lgData[propertyName].lGalleryOn) {
                    lgData[propertyName].destroy();
                }
            }
        }
    }

    public phoneCall() {
        GTagHelper.sendEvent("click", "phone", "info_request");
    }

    public whatsApp() {
        GTagHelper.sendEvent("click", "whatsapp", "info_request");
    }

    public isValidationError(controlName: string): boolean {
        return FormHelper.isControlValidationError(controlName, this.validationErrors);
    }
};